import {useMemo} from 'react';
import {useProgramSession} from '../schedule/useProgramSession';
import {useEventParticipants} from './useEventParticipants';

export function useActiveParticipantsInSession(eventId, sessionId) {
    const participants = useEventParticipants(eventId),
        session = useProgramSession(eventId, sessionId);

    return useMemo(() => {
        if (session?.is_selectable) {
            return participants.filter(participant => participant.program_selection.includes(sessionId));
        }
        return participants;
    }, [participants, session]);
}
